export interface TutorialStep {
  title: string;
  description: string;
  image?: string;
}

export const RAINBOW_DANCE_TUTORIAL: TutorialStep[] = [
  {
    title: 'Welcome to Rainbow Dance!',
    description: 'A fun rhythm game where you match dance moves to the beat.',
    image: '/images/tutorials/rainbow-dance-intro.png'
  },
  {
    title: 'Game Modes',
    description: 'Choose between Feet, Hands, or Combo mode. Each mode tests different skills!',
    image: '/images/tutorials/rainbow-dance-modes.png'
  },
  {
    title: 'How to Play',
    description: 'Follow the on-screen patterns. Match the moves quickly and accurately to score points!',
    image: '/images/tutorials/rainbow-dance-gameplay.png'
  },
  {
    title: 'Multiplayer Fun',
    description: 'Play with friends! Take turns and see who can get the highest score.',
    image: '/images/tutorials/rainbow-dance-multiplayer.png'
  }
];